module.exports = __webpack_public_path__ + "static/media/Click1.1ab02b4b.mp3";